import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Guardian = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb431__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb431__a)">
            <path
              fillRule="evenodd"
              d="M3.004 41.353q-.03-.708.125-1.538.273-1.46 1.048-2.754 1.12-1.872 3.129-3.14 2.285-1.444 5.594-2.002l.048-.008.024-.003q1.466-.202 2.81-.546.903-.231 1.433-.447-.013-.234-.039-.52-.13-1.423-.865-2.648-.463-.772-1.623-2.051l-.01-.012q-.83-.914-1.18-1.404-.977-1.372-1.426-3.132-.234-.915-.271-1.643a1.995 1.995 0 0 1-.003-.1q-.001-1.11.543-1.985.054-.087.118-.175-.162-1.17-.178-2.562-.02-1.75.2-3.091.13-1.839 1.398-3.585.553-.761 1.166-1.32-.047-.487.046-.956.157-.795.684-1.414.68-.798 1.797-1.088.506-.13 1.275-.169 2.047-.104 3.28-.012 5.019.373 8.475 2.029 1.958.938 2.899 1.96l.044.05q1.204 1.4 1.734 3.35.154.564.22 1.046.319 1.842.18 4.373-.035.622-.125 1.34.309.45.462.926.184.571.184 1.242c0 .028 0 .057-.002.085q-.031.744-.271 1.691-.448 1.764-1.428 3.14-.35.49-1.18 1.405-1.168 1.287-1.633 2.062-.735 1.225-.864 2.648-.026.286-.04.52.534.217 1.446.45 1.432.366 2.763.538c.033.004.065.01.097.015q3.364.604 5.645 2.05 2.014 1.276 3.124 3.137.767 1.287 1.026 2.732.148.823.11 1.534v.86q0 1.164-.838 1.979-.814.79-1.953.79H5.795q-1.14 0-1.953-.79-.838-.815-.838-1.979v-.878ZM30.78 31.44l.026.09-.026-.09ZM12.573 17.947l.004.02-.004-.02ZM7.003 41H41q-.008-.2-.054-.458-.13-.727-.525-1.389-.62-1.04-1.829-1.806-1.604-1.017-4.165-1.484-1.548-.203-3.189-.622-3.682-.94-4.257-2.554a2.004 2.004 0 0 1-.142-.445q-.137-.71-.001-2.21.212-2.334 1.418-4.344.669-1.113 2.101-2.691.672-.74.885-1.039.544-.764.807-1.8.118-.465.146-.774l-.024-.025-.01-.01q-.114-.117-.183-.197l-.002-.004q-.643-.748-.475-1.847.143-.938.183-1.665.116-2.1-.132-3.5a2.02 2.02 0 0 1-.014-.094q-.03-.228-.118-.554-.287-1.053-.88-1.76-.073-.071-.284-.23-.567-.423-1.382-.814-2.777-1.33-7.044-1.648-.931-.069-2.594.01.036.42-.096.858a2 2 0 0 1-.236.51q-.363.564-1.124 1.192-.308.261-.665.752-.612.843-.647 1.558a1.991 1.991 0 0 1-.027.244q-.176 1.02-.16 2.479.016 1.482.225 2.582.175.87-.16 1.567a2 2 0 0 1-.468.625l-.067.06q.035.286.136.686.265 1.036.809 1.8.211.296.874 1.027l.01.011q1.433 1.578 2.101 2.691 1.206 2.01 1.419 4.345.136 1.5-.002 2.209a2.004 2.004 0 0 1-.151.466q-.612 1.602-4.234 2.53-1.554.397-3.236.63-2.498.426-4.096 1.435-1.202.759-1.832 1.812-.407.68-.548 1.434-.047.254-.058.45Zm14.031-8.37q.016-.046.029-.093-.013.047-.029.094Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
